const database = [
  {
    title: "Exclusive Preview: Diving into Dolphin's Quest",
    description: "",
    category: "News",
    media: "2022/1/10/dqp/caption.jpg",
    byline: "Johnny L. de Alba | 1.10.22",
    url: "2022/1/10"
  },

  {
    title: "Happy Two Year Anniversary Ecco Online!",
    description: "",
    category: "News",
    media: "2021/11/14/hty/caption.png",
    byline: "Johnny L. de Alba | 11.14.21",
    url: "2021/11/14"
  },

  {
    title: "JAMATAR Musician, Chiptune Artist and Sound Engineer",
    description: "",
    category: "Community Spotlight",
    media: "2021/8/8/jgj/caption.png",
    byline: "Johnny L. de Alba | 8.8.21",
    url: "2021/8/8"
  },

  {
    title: "The Motion Physics of Ecco the Dolphin",
    description: "",
    category: "Hacking",
    media: "2020/12/21/emp/caption.png",
    byline: "Johnny L. de Alba | 12.21.20",
    url: "2020/12/21"
  },

  {
    title: "How To Modify The Files In A Dreamcast ROM Image",
    description: "",
    category: "Hacking",
    media: "2020/11/13/htm/caption.jpg",
    byline: "Moduvator | 11.13.20",
    url: "2020/11/13"
  },

  {
    title: "Ecco DOTF Prototype 11-1999 for Dreamcast",
    description: "",
    category: "Prototypes",
    media: "2020/11/10/edp/caption.png",
    byline: "Moduvator | 11.10.20",
    url: "2020/11/10"
  },

  {
    title: "Happy 1 Year Anniversary to Ecco the Dolphin Online!",
    description: "",
    category: "News",
    media: "2020/11/9/hoy/caption.jpg",
    byline: "Johnny L. de Alba | 11.9.20",
    url: "2020/11/9"
  },

  {
    title: "Ecco the Dolphin Online",
    description: "An Ecco the Dolphin community dedicated to reverse engineering, game oddities and preservation of resources pertaining to the series.",
    category: "",
    media: "caption.png",
    byline: "",
    url: ""
  },
];

module.exports = {
  database: database
} 
